import { connect } from 'react-redux';

import { resetAddressSuggestion } from 'redux/modules/address-suggestion/actions';
import { onHideChooseAddress } from 'redux/modules/address/actions';
import {
  getActiveAddresses,
  getAddressInError,
  getIsChosenAddressModalOpen,
} from 'redux/modules/address/selectors';

import historyUtils from 'utils/history';
import locator from 'utils/locator';
import urls from 'constants/urls';
import { withRouteProps } from 'utils/with-route-props';

import ChooseAddressModal from './ChooseAddressModal';

const mapStateToProps = (state, props) => {
  const { location, pageTitle = 'Change Address' } = props;
  const addresses = getActiveAddresses(state);
  const addressInError = getAddressInError(state);
  const isOpen = getIsChosenAddressModalOpen(state);
  const { hash = '' } = location;

  return {
    location: { hash },
    isOpen: isOpen && Object.values(urls.addressModals).includes(hash),
    addresses,
    pageTitle,
    hasError: addressInError !== null,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  closeModal: cancelled => {
    dispatch(onHideChooseAddress(cancelled));
    ownProps.onAfterSelect(null);
  },
  onAfterClose: () => {
    dispatch(resetAddressSuggestion());
    historyUtils.replace(`${locator.pathname}${locator.search}${'#'}`);
  },
  showAddAddress: () => dispatch(resetAddressSuggestion()),
});

export default withRouteProps(connect(mapStateToProps, mapDispatchToProps)(ChooseAddressModal));
